import React from 'react';
import { Spinner } from 'components/core';
import { UserRow } from 'modules/multi-user/components/user-row/user-row';

// hooks
import { useBusinessMembers } from 'hooks/business/use-business-members';

export const UserList: React.FC = () => {
  const { data: businessMembers, isLoading } = useBusinessMembers();

  if (isLoading) {
    return <Spinner />;
  }

  if (!businessMembers) {
    return null;
  }

  return businessMembers?.map((member: any) => (
    <UserRow user={member} key={member.id ?? member.personId ?? member.email} />
  ));
};
